import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import Login from '../pages/auth/Login';
import LoadingScreen from '../components/LoadingScreen';

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, initializeAuth } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  const [initializationAttempted, setInitializationAttempted] = useState(false);

  // Appel explicite de l'initialisation
  useEffect(() => {
    if (!initializationAttempted && !isInitialized) {
      initializeAuth().then(() => setInitializationAttempted(true));
    }
  }, [initializeAuth, initializationAttempted, isInitialized]);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};